<template>
  <div class="container-fluid">
    <TheHeader :stationName="viewName" />
    <div class="ps-4 pe-4 pt-3">
      <FoilCutterForm
        :station-id="stationId"
        :table-url="tableUrl"
      ></FoilCutterForm>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import TheHeader from "@/components/layouts/TheHeader.vue";
import FoilCutterForm from "@/components/foilcutter/FoilCutterForm.vue";

const stationId = 17;
const tableUrl = `/Material/GetLastMaterialFoil/17/15`;
const viewName = "Foil Cutter 2";

onMounted(() => {
  document.title = viewName;
});
</script>
